import * as React from 'react';
import { FC, memo } from 'react';

import Maybe from 'graphql/tsutils/Maybe';
import { useNavigate } from 'react-router-dom';

import { useOffersUIContext } from 'components/offers/ui-refresh/offers-ui-context';
import { IOffersSelectRestaurantCta } from 'components/offers/ui-refresh/use-feature-offers';

import { SelectRestaurantCtaView } from './select-restaurant-cta.view';
import { NoNullFields } from './types';

/**
 *
 * Displays a CTA to select restaurant if available number of non-restaurant specific offers falls below
 * the "minimumNumberOfOffers" number set in Sanity.
 *
 */

const dataIsValid = (
  data: Maybe<IOffersSelectRestaurantCta>
): data is NoNullFields<IOffersSelectRestaurantCta> => {
  return !!data && Object.values(data).every(Boolean);
};

const SelectRestaurantCta: FC = () => {
  const { featureOffers } = useOffersUIContext();
  const { offersSelectRestaurantCta } = featureOffers?.offersBrowsingPanel ?? {};
  const navigate = useNavigate();

  if (!dataIsValid(offersSelectRestaurantCta)) {
    return null;
  }

  const { title, body, ctaButtonText, link } = offersSelectRestaurantCta;

  const handleClick = () => navigate(link);

  return (
    <SelectRestaurantCtaView
      title={title}
      body={body}
      ctaButtonText={ctaButtonText}
      onClick={handleClick}
    />
  );
};

export default memo(SelectRestaurantCta);
